
const defaultTheme = {
    bgColor: 'white',
    bgColorHover: 'red',
    fontFamily: 'Commissioner',
  };

  export default defaultTheme;
